<script setup>
import { useMenuStore } from '@/store/menu';
import { nextTick, onMounted, reactive, ref, watch } from 'vue';
import { Search } from '@element-plus/icons-vue';
import { searchApi } from './api';

const open = ref(false);
const position = reactive({
  '--search-left': 0,
  '--search-top': 0,
});
const setPosition = () => {
  const input = document.querySelector('.search-component-input');
  console.log({ input });
  position['--search-left'] = `${input.offsetLeft + 50}px`;
  position['--search-top'] = `${input.offsetTop + 10}px`;
};
const menus = useMenuStore();
watch(() => menus.menus, setPosition);
onMounted(() => {
  setTimeout(setPosition);
  window.addEventListener('resize', setPosition);
});
const keyword = ref('');
const dataList = ref([]);

const onKeydown = (e) => {
  if (e.key === 'Escape') {
    open.value = false;
  }
};

let time = 0;
const loading = ref(false);
const onInput = () => {
  loading.value = true;
  clearTimeout(time);
  time = setTimeout(() => {
    if (!keyword.value) {
      dataList.value = [];
      loading.value = false;
      return;
    }
    searchApi(keyword.value)
      .then((res) => {
        dataList.value = res.map((item) => {
          const md = item.search_text;
          const index = md?.indexOf(keyword.value);
          let p = '';
          let n = '';
          let content = md?.slice(index, index + 100) || '';
          if (index > 0) {
            p = '...';
          }
          if (index + 100 < md.length) {
            n = '...';
          }
          // 关键字高亮
          content = content.replace(keyword.value, `<span style="color: red">${keyword.value}</span>`);

          return {
            ...item,
            content: p + content + n,
          };
        });
      })
      .finally(() => {
        loading.value = false;
      });
  }, 300);
};

const toDocument = ({ group_name, name }) => {
  // 先找到分组的父级菜单
  const parent = menus.menus.find((m) => m.children.some((c) => c.name === group_name));
  menus.toSearch(parent.name, name);
  open.value = false;
  // 清空搜索关键字
  nextTick(() => {
    keyword.value = '';
    dataList.value = [];
  });
};
</script>
<template>
  <div class="search-component-input" @click="open = true">
    <el-icon :size="20" color="#999"><Search /></el-icon>
    <span class="input-text">搜索</span>
  </div>
  <div :style="position" class="search-component-view" :class="{ open }" @click="open = false">
    <div class="search-form" @click.stop="1" @keydown="onKeydown">
      <el-input :prefix-icon="Search" class="search-input" placeholder="搜索文档" v-model="keyword" clearable @input="onInput" />

      <div class="not-data" v-if="!dataList.length && !keyword" v-loading="loading">请输入关键字搜索</div>
      <div class="not-data" v-else-if="!dataList.length" v-loading="loading">没有找到文档</div>
      <div class="document-list" v-else v-loading="loading">
        <el-card class="document-item" v-for="item in dataList" :key="item.id" @click="toDocument(item)">
          <div class="document-title">
            {{ item.title }}
          </div>
          <div class="document-content" v-html="item.content"></div>
        </el-card>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.search-component-input {
  width: 100px;
  height: 36px;
  border-radius: 18px;
  border: 2px solid #dcdfe6;
  display: flex;
  align-items: center;
  padding: 0 10px;
  transition: 0.3s;
  background-color: transparent;
  cursor: pointer;

  &:hover {
    border-color: var(--root-color);
    background-color: var(--page-bg);
  }
  .input-text {
    font-size: 16px;
    color: #999;
    line-height: 29px;
    margin-left: 10px;
    margin-bottom: 3px;
  }
}
.search-component-view {
  position: fixed;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  z-index: 9999;
  background-color: #fffd;
  transform: translateX(var(--search-left)) translateY(var(--search-top));
  overflow: hidden;
  &.open {
    width: 100%;
    height: 100%;
    transform: translateX(0) translateY(0);
  }
  .search-form {
    width: 500px;
    padding: 10px;
    position: absolute;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #f5f5f5;
    border-radius: 10px;
    min-height: 300px;
    box-shadow: 0 4px 10px 0 #eee;
    .search-input {
      width: 100%;
      height: 60px;
      background-color: transparent;
      font-size: 20px;
    }
    .document-list {
      margin-top: 20px;
      .document-item + .document-item {
        margin-top: 5px;
      }
      .document-title {
        font-weight: 700;
      }
    }
    .not-data {
      text-align: center;
      line-height: 240px;
      color: #999;
    }
  }
}
</style>
